import { foundation } from './foundation';
import { palette } from './palette';

const { black, white, offWhite, blueSoft, success, error, warning } = palette.color;

const mix = (color: string, percent: number, other: string) =>
  `color-mix(in srgb, ${color} ${percent}%, ${other})`;

export const theme = {
  ...foundation,
  alpha: palette.alpha,
  color: {
    ...palette.color,
    text: black,
    textSecondary: mix(black, 78, white),
    textMuted: mix(black, 48, white),
    textInverse: white,
    textInverseMuted: mix(white, 72, 'transparent'),
    surface: white,
    surfaceMuted: offWhite,
    surfaceInverse: black,
    navbar: palette.alpha.white[95],
    border: mix(black, 10, white),
    borderSubtle: mix(black, 6, white),
    borderStrong: mix(black, 16, white),
    borderInverse: mix(white, 16, 'transparent'),
    successBg: mix(success, 12, white),
    successBorder: mix(success, 32, white),
    errorBg: mix(error, 10, white),
    errorBorder: mix(error, 24, white),
    errorHover: mix(black, 14, error),
    warningBg: mix(warning, 12, white),
  },
  gradient: {
    ...palette.gradient,
    surface: `linear-gradient(135deg, ${offWhite} 0%, ${white} 100%)`,
    card: `linear-gradient(135deg, ${white} 0%, ${blueSoft} 100%)`,
  },
};

export type Theme = typeof theme;
